import { render, staticRenderFns } from "./ModalBeamSection.vue?vue&type=template&id=48b9804e&scoped=true&"
import script from "./ModalBeamSection.vue?vue&type=script&lang=js&"
export * from "./ModalBeamSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9804e",
  null
  
)

/* custom blocks */
import block0 from "./ModalBeamSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports